import { useQuery } from "react-query";
import { fetchRecords } from "../api/cosmos-api";

const useRecordsData = ({ options, isEnabled: enabled }) => {
  const {
    isLoading: isRecordsLoading,
    isError: isRecordsError,
    data: recordsData = [],
  } = useQuery(["userdatabase-records", options], fetchRecords, {
    enabled,
    retry: 0,
    select: (response) => {
      const { data: { hits = [] } = {} } = response;
      return hits;
    },
  });

  return { isRecordsLoading, recordsData, isRecordsError };
};

export default useRecordsData;
